module.exports = __webpack_public_path__ + "img/published.c8561ff8.svg";